// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The visual debugger token.
 */
export const IDebugger = new Token('@jupyterlab/debugger:IDebugger', 'A debugger user interface.');
/**
 * The debugger configuration token.
 */
export const IDebuggerConfig = new Token('@jupyterlab/debugger:IDebuggerConfig', 'A service to handle the debugger configuration.');
/**
 * The debugger sources utility token.
 */
export const IDebuggerSources = new Token('@jupyterlab/debugger:IDebuggerSources', 'A service to display sources in debug mode.');
/**
 * The debugger sidebar token.
 */
export const IDebuggerSidebar = new Token('@jupyterlab/debugger:IDebuggerSidebar', 'A service for the debugger sidebar.');
/**
 * The debugger handler token.
 */
export const IDebuggerHandler = new Token('@jupyterlab/debugger:IDebuggerHandler', 'A service for handling notebook debugger.');
/**
 * The source viewer token.
 */
export const IDebuggerSourceViewer = new Token('@jupyterlab/debugger:IDebuggerSourceViewer', 'A debugger source viewer.');
/**
 * Debugger display registry token.
 */
export const IDebuggerDisplayRegistry = new Token('@jupyterlab/debugger:IDebuggerDisplayRegistry', 'A service for registering display labels for cells/files in the debugger.');
//# sourceMappingURL=tokens.js.map